import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { OptionsEntity } from 'site-modules/lease-deals/components/filters/entities/options-entity';
import { ConnectedFilterItemEntity } from 'site-modules/lease-deals/components/filters/entities/group-entities';
import { CONTROL_COMPONENT_MAP } from 'site-modules/lease-deals/components/filters/infrastructure/filters-controls';
import { useSelector, shallowEqual } from 'react-redux';
import { FilterGroup } from 'site-modules/lease-deals/components/filters/ui/primitives/filter-group/filter-group';

export const ConnectedFilterItem = ({ config, options = undefined, onFilterUpdate }) => {
  const { controlProps, control, innerGroupClassName, title } = config;
  const { dataKey } = controlProps;

  const selectMyValues = useCallback(
    state => {
      if (!dataKey) return undefined;
      return state.leaseDeals?.selectedFilters?.[dataKey];
    },
    [dataKey]
  );
  const selectedValues = useSelector(selectMyValues, shallowEqual);

  const handleFilterChange = useCallback(
    newValues => {
      onFilterUpdate(dataKey, newValues);
    },
    [onFilterUpdate, dataKey]
  );

  const hydratedControlProps = {
    ...controlProps,
    options,
    selectedValues,
    onChange: handleFilterChange,
  };

  const ControlComponent = CONTROL_COMPONENT_MAP[control];
  if (!ControlComponent) return null;

  return (
    <FilterGroup title={title} className={innerGroupClassName}>
      <ControlComponent {...hydratedControlProps} />
    </FilterGroup>
  );
};

ConnectedFilterItem.propTypes = {
  config: ConnectedFilterItemEntity.isRequired,
  options: OptionsEntity,
  onFilterUpdate: PropTypes.func.isRequired,
};
